import { createAsyncThunk } from '@reduxjs/toolkit';
import { post } from '../models/base';

const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.content;

export const createOrder = createAsyncThunk(
  'payments/createOrder',
  async (planName, { rejectWithValue }) => {
    try {
      const response = await post(`/transactions/order?plan_name=${planName}`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const verifyTransaction = createAsyncThunk(
  'payments/verifyTransaction',
  async (data, { rejectWithValue, getState }) => {
    const { order } = getState().payments;
    try {
      const res = await fetch(`/transactions/${order.id}/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken(),
        },
        body: JSON.stringify(data),
      });

      if (!res.ok) {
        throw `POST ${res.status} ${res.url}`;
      }

      return;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
